import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
    total_amount:number
}


export const RevenueApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRevenue: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.revenue}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
  }),
});

export const {
 useLazyGetRevenueQuery
} = RevenueApi;
